import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

type TabLabelProps = {
  label: string;
  count: number;
};

export const TabLabel: FC<TabLabelProps> = ({ label, count }) => (
  <StyledTabLabel>
    <span>{label}</span>
    <StyledCount>{count}</StyledCount>
  </StyledTabLabel>
);

const StyledTabLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const StyledCount = styled.div`
  height: 20px;
  padding: 2px 8px;
  border-radius: 6px;
  background: ${COLORS.systemDark50A};
  color: ${COLORS.systemDark300};
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
`;
